import React from 'react'
import './Footer.scss'
export const Footer = () => {
    return (
        <footer className="footer">
            <ul className="nav">
                <li className="nav__item"><a href="/" className="nav__link">Hitta ditt dröm hem</a></li>
                <li className="nav__item"><a href="/" className="nav__link">Ange ett förslag</a></li>
                <li className="nav__item"><a href="/" className="nav__link">Ladda ned hemplanera</a></li>
                <li className="nav__item"><a href="/" className="nav__link">Kontakta oss</a></li>
                <li className="nav__item"><a href="/" className="nav__link">Skicka in din egendom</a></li>
                <li className="nav__item"><a href="/" className="nav__link">Kom och jobba hos oss!</a></li>


            </ul>
            <p className="copyright">
                &copy; Copyright 2020 by Jonathan. Feel free to use this site for your needs and style it. Lorem ipsum.
            </p>
        </footer>
    )
}
